import { Tooltip, Typography } from 'shared/ui'
import { Icon } from 'shared/ui/Icon'
import { ChatbotBookingType } from 'entities/Chatbot'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { BOOKING_METHOD_OPTIONS } from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/store/bookingWidgetStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/BookingSection/styles.module.scss'

type IBookingStep3Props = {
  focusedIndex: number
  isHubspotSelected: boolean
  onSelect: (index: number) => void
}

export const BookingStep3 = ({ focusedIndex, isHubspotSelected, onSelect }: IBookingStep3Props) => (
  <div className={styles.list}>
    {BOOKING_METHOD_OPTIONS.map((item, index) => {
      const isDisabled = isHubspotSelected && item.id === ChatbotBookingType.ShareLink

      return (
        <WidgetItem
          key={item.id}
          isFocused={!isDisabled && index === focusedIndex}
          isDisabled={isDisabled}
          badgeIndex={index}
          onClick={isDisabled ? undefined : () => onSelect(index)}
          rightNode={
            isDisabled ? (
              <Typography
                variant={'body-rg-regular'}
                ariaLabel={'coming-soon'}
                color={'var(--content-primary-disabled)'}
              >
                Coming soon
              </Typography>
            ) : item.tooltip ? (
              <Tooltip
                label={item.tooltip}
                placement='top'
                ariaLabel={item.label}
                breakWord
                width={246}
              >
                <Icon icon={'question'} className={styles.tooltipIcon} />
              </Tooltip>
            ) : undefined
          }
        >
          <Typography variant={'body-rg-regular'} ariaLabel={item.label}>
            {item.label}
          </Typography>
        </WidgetItem>
      )
    })}
  </div>
)
